import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface SelectDeviceViewEntityCommand {
  deviceViewEntityId: DeviceViewEntityId;
}

export const selectDeviceViewEntity: DeviceViewCommandFactory<
  SelectDeviceViewEntityCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.activeDeviceViewEntityId = command.deviceViewEntityId;
  });
};
